export default __webpack_public_path__ + "static/media/Learn_responsive_design_-_adamr.space___Codecademy.6f24be0b.pdf";